<template>
<div>
  <pc-navbar/>
  <div class="company-list-main">
    <div class="search">
      <search background="#fff"/>
      <div class="tag">
        <div>热门搜索：</div>
        <div class="tag-menu">123</div>
        <div class="tag-menu">123</div>
        <div class="tag-menu">123</div>
        <div class="tag-menu">123</div>
      </div>

    </div>
    <div class="list">
      <item
        class="item"
        v-for="(item, index) in 10"
        :key="index"/>
    </div>
    <page/>
  </div>
  <pc-footer/>
</div>
</template>
<script>
import PcNavbar from '@/components/base/navbar';
import PcFooter from '@/components/base/pcFooter';
import Search from '@/components/search';
import Item from './components/item';
import Page from '@/components/newPage';
import api from '@/api';
export default {
  name: 'CompanyList',
  components: {
    PcNavbar,
    PcFooter,
    Search,
    Page,
    Item
  },
  data() {
    return {
      queryData: {
        size: 20,
        from: 0,
        keyword: 'wondercv'
      }
    };
  },
  async mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await api.company.getCompanyList(this.queryData);
      console.log(res);
    }
  },
}
</script>
<style lang="scss" scoped>
.company-list-main {
  width: 1196px;
  margin: auto;
  padding-top: 55px;
  * {
    box-sizing: border-box;
  }
  .search {
    width: 900px;
    height: 156px;
    padding-top: 28px;
    margin: auto;
    .tag {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #9C9C9C;
      margin-top: 10px;
      &>div {
        margin-right: 24px;
      }
      .tag-menu {
        color: #FF6644;
        cursor: pointer;
        &:hover {
          opacity: .8;
        }
      }
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-right: 16px;
      margin-bottom: 16px;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>